import React, { useState, useEffect } from 'react';
import { ActiveEditContainer } from './styles';
import { get, last } from 'global/lib/lodash';
import { getId } from './utils';
import { SystemScore } from './SystemScore';

let ISUPDATING = false;
let NEEDSUPDATE = false;

export const ActiveEdit = (props) => {
  const { activeEdit, assessment, setSidebarOpen, setActiveEdit, updateScores, setCurrentAnchor, treedProcessedScoreData, selectedItems, filter, scorecard, isCourse } = props;
  const [dir, setDir] = useState();
  const [childProps, setChildProps] = useState({
    isCourse,
    assessment,
    system: {},
    checklist: {},
  });
  const [state, setState] = useState({
    needsUpdate: false,
    isUpdating: false,
  });

  const setNeedUpdate = () => {
    NEEDSUPDATE = true;
  };

  useEffect(() => {
    const searchChildren = (children, id) => {
      const childs = children || [];
      let found = childs.find((c) => getId(c) == id);

      if (found) {
        return found;
      } else {
        for (let i = 0; i < childs.length; i++) {
          found = searchChildren(childs[i].children, id);
          if (found) {
            break;
          }
        }
      }
      return found;
    };

    const findCurrentChecklist = (pSystem) => {
      if (activeEdit) {
        const pSystemIndex = treedProcessedScoreData.findIndex((t) => getId(t) === getId(pSystem));
        const checklists = get(pSystem, 'children', []);
        return {
          checklists,
          nextSystem: get(treedProcessedScoreData, pSystemIndex + 1),
          prevSystem: get(treedProcessedScoreData, pSystemIndex - 1),
          currentIndex: checklists.findIndex((f) => getId(f) === getId(get(activeEdit, 'pssvChecklist'))),
        };
      } else {
        return undefined;
      }
    };

    if (activeEdit) {
      const pssvSystem = searchChildren(treedProcessedScoreData, getId(activeEdit.pssvSystem));
      const pchecklist = searchChildren(treedProcessedScoreData, getId(activeEdit.pssvChecklist));

      const checklist = findCurrentChecklist(pssvSystem);
      if (checklist && checklist.currentIndex !== -1) {
        const next = get(checklist.checklists, checklist.currentIndex + 1, { ...get(checklist.nextSystem, 'children.0'), _system: checklist.nextSystem });
        const prev = get(checklist.checklists, checklist.currentIndex - 1, { ...last(get(checklist.prevSystem, 'children', [])), _system: checklist.prevSystem });
        setDir({
          next,
          prev,
        });
      }
      setChildProps({
        isCourse,
        assessment,
        pssvSystem,
        pssvChecklist: pchecklist,
      });
    }
  }, [treedProcessedScoreData, activeEdit]);

  useEffect(() => {
    return () => {
      if (NEEDSUPDATE && !ISUPDATING) {
        ISUPDATING = true;
        setState((s) => ({ ...s, isUpdating: true }));
        updateScores(null, true)
          .then(() => {
            NEEDSUPDATE = false;
          })
          .finally(() => {
            ISUPDATING = false;
            setState((s) => ({ ...s, isUpdating: false }));
          });
      }
    };
  }, [activeEdit]);

  const _props = {
    ...props,
    next: get(dir, 'next'),
    prev: get(dir, 'prev'),

    ...state,

    setSidebarOpen,
    setActiveEdit,
    activeEdit,
    setCurrentAnchor,
    updateScores,
    selectedItems,
    filter,
    scorecard,
    setNeedUpdate,

    ...childProps,
  };

  return (
    <ActiveEditContainer>
      <SystemScore {..._props} />
    </ActiveEditContainer>
  );
};
